
import APIClient from './APIClient'

class CEmployeesAPI {


  async create({ name, id_code, division_id }) {
    const res = await APIClient.POST('/employees', {
      name, 
      id_code,
      division_id
    })
    return res
  }

  async get(id) {
    const res = await APIClient.GET('/employees/'+id)
    return res
  }

  async update(id, { name, id_code, division_id }) {
    const res = await APIClient.POST('/employees/'+id, {
      name, 
      id_code,
      division_id
    })
    return res
  }

  async delete(id) {
    const res = await APIClient.DELETE('/employees/'+id)
    return res
  }

  async list(params) {
    const q = {}
    if (params.search) q.search = params.search 
    if (!isNaN(params.skip)) q.skip = params.skip 
    if (!isNaN(params.limit)) q.limit = params.limit
    const res = await APIClient.GET('/employees', Object.keys(q).length > 0 ? q : undefined)
    return res
  }

}

const EmployeesAPI = new CEmployeesAPI()

export default EmployeesAPI



// WEBPACK FOOTER //
// ./src/api/EmployeesAPI.js